/* eslint-disable */
import {
  DirectDebitValidationRequest,
  DirectDebitValidationResponse,
} from '../models/direct.debit.model';

export const mockDirectDebitValidationRequest: DirectDebitValidationRequest = {
  request_source: 'BVUK',
  channel_code: '0035',
  channel_group_code: '0005',
  client_code: '00351',
  client_group_code: '00296',
  branchCode: '123456',
  accountNumber: '123456',
};

export const mockDirectDebitValidationResponse: DirectDebitValidationResponse =
  {
    isValid: true,
  };
